
import Vue from 'vue'
import { namespace } from 'vuex-class';
import { DomainModal, UserManagementState, Domain } from '@/store/user-management/types';
import Component from 'vue-class-component';
import AreaTreeSelect from "@/components/form/AreaTreeSelect.vue";
import UserGroupDomains from '../../users/UserGroupDomains.vue';
import { Watch } from 'vue-property-decorator';
import tree from '@/components/Tree.vue';

const UserManagement = namespace("userManagement");

@Component({
    components:{
        "area-tree-select": AreaTreeSelect
    }
})
export default class AddEditDomainModal extends Vue {
    @UserManagement.Mutation setDomainModalShown: (domainModal: DomainModal) => void;
    @UserManagement.State((state: UserManagementState) => state.domainModal) private domainModal: DomainModal;
    @UserManagement.Action createDomain: (domain: Domain) => Promise<void>;
    @UserManagement.Action updateDomain: (domain: Domain) => Promise<void>;
    @UserManagement.Getter private getDomain: (domainId: number) => Domain;
    @UserManagement.State((state: UserManagementState) => state.domains) private domains: Domain[];

    readonly stringMaxLength: number = 255

    private currentDomainInfo: Domain = {
        domainId: 0,
        domainName: "",
        groupId: null
    }

    private originalDomainInfo: Domain = {
        domainId: 0,
        domainName: "",
        groupId: null        
    }


    public closeDomainModal(): void {
        this.currentDomainInfo = {
            domainId: 0,
            domainName: "",
            groupId: null
        }
        this.originalDomainInfo = {
            domainId: 0,
            domainName: "",
            groupId: null
        }
		this.setDomainModalShown({shown: false, domainId: 0});
	}

    private get editMode(): boolean{
        if(this.domainModal.domainId > 0){
            this.originalDomainInfo = this.getDomain(this.domainModal.domainId)
            this.currentDomainInfo =  {
                domainId: this.originalDomainInfo.domainId,
                domainName: this.originalDomainInfo.domainName,
                groupId: this.originalDomainInfo.groupId
            };

            return true;
        }
        return false;
    }

    private saveDomain(): void {
        this.createDomain(this.currentDomainInfo);
        this.closeDomainModal();
    }

    private editDomain(): void {
        this.updateDomain(this.currentDomainInfo);
        this.closeDomainModal();
    }

    private get disableSave(): boolean {
        if(this.currentDomainInfo.domainName == ""){
            return true;
        }

        if(this.currentDomainInfo.groupId == 0 || this.currentDomainInfo.groupId == null){
            return true;
        }

        if(!this.validation){
            return true;
        }

        if( this.editMode
            && this.currentDomainInfo.domainName == this.originalDomainInfo.domainName 
            && this.currentDomainInfo.groupId == this.originalDomainInfo.groupId )
        {
            return true;
        }

        return false;
    }

    private get validation():boolean {
        let found = this.domains.find(d => d.domainName.toLowerCase() == this.currentDomainInfo.domainName.toLowerCase())
        if( found != null && !this.editMode){
            return false;
        }
        else if (this.currentDomainInfo.domainName.length > this.stringMaxLength) {
            return false;
        }
        else if (this.currentDomainInfo.domainName == "") {
            return false;
        }
        else if (this.currentDomainInfo.domainName.indexOf(' ') >= 0) {
            return false;
        }
        else {
            return true;
        }
    }

    private get invalidFeedback(): string {
        let found = this.domains.find(d => d.domainName.toLowerCase() == this.currentDomainInfo.domainName.toLowerCase())
        if( found != null && !this.editMode){
            return "Domain name already exists";
        }
        else if (this.currentDomainInfo.domainName.length > this.stringMaxLength) {
            return "Maximum Length is 255 Characters";
        }
        else if (this.currentDomainInfo.domainName == "") {
            return "Enter Domain name with no spaces";
        }
        else if (this.currentDomainInfo.domainName.indexOf(' ') >= 0) {
            return "No spaces are allowed in the domain name";
        }
        else{
            return "";
        }
    }
}
